import React, { useState, useContext, useEffect, useMemo, useRef } from 'react';
import { useParams } from 'react-router-dom';

import APICtx from '#api'
import { TplWSidebar as Tpl } from '#Template'
import DataList from '#DataList'
import Dialog from '#Dialog'
import { faEdit, faMagnifyingGlass, faDownload, faInboxOut, faUsersGear, faPaperPlane, faPrint, faFire } from '@fortawesome/pro-regular-svg-icons'

import EditF24 from './EditF24'

import { campaigns, campaignStatuses, evalEditable, evalEvaluable, evalPaperBuildable, evalSendable } from './def'
import { Typography } from '@mui/material';

const EditCampaign = ({ row, handleClose }) => {
	const campaignDef = useMemo(() =>
		row?.type && campaigns.find(item => item.tag === row.type)
	, [ row ])

	return (
		<Dialog
			handleClose={handleClose}
			open={Boolean(campaignDef?.isEditable)}
			title={"Campagna: " + (campaignDef?.label || '')}
			width="md"
		>
			{ campaignDef?.tag === 'f24' && <EditF24 _id={row._id} /> }
		</Dialog>
	)
}

const CaimpaignType = ({ type, description }) => {
	const label = campaigns.find(scanItem => type === scanItem.tag )?.label || '???'

	const result = [
		<Typography>{label}</Typography>
	]

	description && result.push(
		<Typography variant='caption'>{description}</Typography>
	)

	return result
}

const useTableDef = (zones) => {
	const zonesRef = useRef(zones)
	zonesRef.current = zones

	return useMemo(() => ([
		{ label:"Numero", content:row => row?._registry?.num || row?._registry?.number },
		{ label:"Data creazione", field:'_createdAt', type:'datetime' },
		{ label:"Tipologia", content:row => <CaimpaignType {...row} /> },
		{ label:"Zona", content:row => {
			const currentZones = zonesRef.current
			return (
				row.zoneZID &&
				currentZones.find(zone => zone.zid === row.zoneZID)?.label
			) || '-'
		}},
		{ label:"Stato", content:row => campaignStatuses.find(scanItem => row.status === scanItem.value )?.label || '-' },
	]), [ zones ])
}

export default function MailerList() {
	const api = useContext(APICtx)
	const { type, processId } = useParams()
	const [ ids, setIds ] = useState([])
	const [ editCampaign, setEditCampaign ] = useState()
	const [zones, setZones] = useState([])

	useEffect(() => {
		api.call('zone/options').then(result => {
			setZones(Array.isArray(result) ? [...result] : [])
		})
	}, [api])

	const tabDef = useTableDef(zones)

	const handleRefresh = () => api.call('mailer/list-v2', { type, processId }).then(setIds)
	const handleEvaluate = ({ _id, _registry, handleRowRefresh }) => {
		api.dialogConfirm({
			text: 'Generare la lista destinatari per la campagna "' + _registry?.num + '"?',
			onConfirm: () => api.call('mailer/evaluate', { _id }).then(handleRowRefresh),
		})
	}
	const handleSend = ({ _id, _registry, handleRowRefresh }) => {
		api.dialogConfirm({
			text: 'Iniziare l\'invio per la campagna "' + _registry?.num + '"?',
			onConfirm: () => api.call('mailer/send', { _id }).then(handleRowRefresh),
		})
	}
	const handlePaperBuild = ({ _id, _registry, handleRowRefresh }) => {
		api.dialogConfirm({
			text: 'Generare l\'invio cartaceo per la campagna "' + _registry?.num + '"?',
			onConfirm: () => api.call('mailer/build-paper', { _id }).then(handleRowRefresh),
		})
	}
	const handleDropSend = ({ _id, _registry }) => {
		api.dialogConfirm({
			text: 'Sei sicuro di voler interrompere l\'invio ai destinatari rimanenti per la campagna "' + _registry?.num + '"?',
			onConfirm: () => api.call('mailer/send-drop', { _id }).then(handleRefresh),
		})
	}
	useEffect(() => {
		handleRefresh()
	}, [ type, processId ])

	const getRow = _id => api.call('mailer/get', { _id })

	const defBtns = [
		{
			icon: faEdit,
			label: 'Modifica',
			onClick: setEditCampaign,
			show: evalEditable,
		},
		{
			icon: faMagnifyingGlass,
			label: 'Anteprima allegato',
			onClick: row => api.storage.download(row.pdfJwt, true),
			show: row => Boolean(row.pdfJwt),
		},
		{
			icon: faDownload,
			label: 'Scarica allegato',
			onClick: row => api.storage.download(row.pdfJwt, false),
			show: row => Boolean(row.pdfJwt),
		},
		{
			icon: faUsersGear,
			label: 'Genera destinatari',
			onClick: handleEvaluate,
			show: evalEvaluable,
		},
		{
			icon: faPaperPlane,
			label: 'Inizia invio',
			onClick: handleSend,
			show: evalSendable,
		},
		{
			icon: faInboxOut,
			label: 'Lista destinatari',
			linkTo: row => '/mailer/rcpts/' + row._id,
			show: row => campaignStatuses.find(scanItem => row.status === scanItem.value )?.showRcpts,
		},
		{
			icon: faPrint,
			label: 'Genera invio cartaceo',
			onClick: handlePaperBuild,
			show: evalPaperBuildable,
		},
	]
	api.auth.chk('mailer-admin') && defBtns.push(
		{
			icon: faFire,
			label: 'Manda in errore gli invii rimanenti',
			onClick: handleDropSend,
			show: row => row.status === 'sending'
		},
	)

	return (
		<Tpl title="Lista campagne d'invio">
			<EditCampaign row={editCampaign} handleClose={() => setEditCampaign(null)} />
			<DataList def={tabDef} ids={ids} getRow={getRow} rowActions={defBtns} pageSize={30} />
		</Tpl>
	)
}